// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-badge":"sapcnqr-badge-01952a","sapcnqr-badge--muted":"sapcnqr-badge--muted-f2f519"};